<app-spinner></app-spinner>
<div role="main">
 <ebb-portal-app-page></ebb-portal-app-page>
</div>



